import React, { useCallback, useContext, useState } from 'react';
import classNames from 'classnames';
import { ENQUIRY_ROUTES } from '../../utils';
import { useTranslation } from 'react-i18next';
import { Button, Loader } from 'ncoded-component-library';
import { Field, Form } from 'react-final-form';
import InputField from 'components/InputField';
import validate from 'validations';
import AuthContext from 'providers/Auth/Auth.context';
import EnquiryListingContext from '../../providers/EnquiryListing';
import UserIcon from 'icons/User.icon';
import { ReactComponent as LinkedIn } from 'icons/linkedin.svg';
import { ReactComponent as Google } from 'icons/google.svg';
import { ReactComponent as Facebook } from 'icons/facebook.svg';
import ArrowdownIcon from 'icons/Arrowdown.icon';
import env from 'env';
import { LoginForm } from 'models/AuthBody';
import EmailOrPhoneFieldWrapper from 'components/EmailOrPhoneFieldWrapper';
import useEnquiryReroute from '../../hooks/useEnquiryReroute';

import './EnquirySliderLogin.styles.scss';
import './EnquirySliderLogin.styles.responsive.scss';

const EnquirySliderLogin: React.FC = () => {
  const [socialMediaOpen, setSocialMediaOpen] = useState(false);

  const { loginRequest } = useContext(AuthContext);
  const { setEnquiryRoute } = useContext(EnquiryListingContext);

  const location = useEnquiryReroute();

  const { t } = useTranslation();

  const classes = classNames('enquiry-slider-login');

  const handleSubmit = useCallback(
    async (values: LoginForm) => {
      await loginRequest(values, location);
    },
    [loginRequest, location],
  );

  return (
    <div className={classes}>
      <p className="enquiry-title">{t('signIn')}</p>

      <Form
        onSubmit={handleSubmit}
        render={({ handleSubmit, submitting }) => (
          <form onSubmit={handleSubmit}>
            {submitting && <Loader />}

            <div>
              <EmailOrPhoneFieldWrapper />
              <span />
              <Field
                label={t('password')}
                placeholder={t('password')}
                name="password"
                type="password"
                component={InputField}
                validate={validate.required()}
                required
              />
              <span />
            </div>
            <div
              className={classNames('enquiry-slider-login__social-media', {
                open: socialMediaOpen,
              })}
            >
              <Button
                onClick={() => setSocialMediaOpen((prev) => !prev)}
                variant="link"
                iconPosition="right"
                icon={ArrowdownIcon}
              >
                {t('signInWithSocialMedia')}
              </Button>
              <div className="links">
                <a href={`${env.SERVER_ENDPOINT}/api/auth/linkedin`}>
                  <LinkedIn />
                  LinkedIn
                </a>
                <a href={`${env.SERVER_ENDPOINT}/api/auth/facebook`}>
                  <Facebook />
                  Facebook
                </a>
                <a href={`${env.SERVER_ENDPOINT}/api/auth/google`}>
                  <Google />
                  Google
                </a>
              </div>
            </div>
            <Button
              variant="link"
              className="signup-button"
              icon={UserIcon}
              onClick={() => setEnquiryRoute(ENQUIRY_ROUTES.SIGN_UP)}
            >
              {t('noAccountCreateOne')}
            </Button>
            <div className="enquiry-slider-sign-up__actions">
              <span />

              <Button type="submit" disabled={submitting}>
                {t('signIn')}
              </Button>
            </div>
          </form>
        )}
      />
    </div>
  );
};

export default EnquirySliderLogin;
